import moment from 'moment';
export const customDurationFormat = (seconds) => {
  const duration = moment.duration(seconds, 'seconds');
  const h = duration.hours();
  const m = duration.minutes();
  const s = duration.seconds();
  return moment({ hour: h, minute: m, second: s }).format('HH:mm:ss');
};
